import { render, staticRenderFns } from "./m-orm-billing-discount-dialog.vue?vue&type=template&id=16e80fba&scoped=true&lang=pug&"
import script from "./m-orm-billing-discount-dialog.vue?vue&type=script&lang=js&"
export * from "./m-orm-billing-discount-dialog.vue?vue&type=script&lang=js&"
import style0 from "./m-orm-billing-discount-dialog.vue?vue&type=style&index=0&id=16e80fba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e80fba",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
